import { PLEDGE_MAX } from 'src/components/Validation'
import useValidation from '../useValidation'

const useValidations = ({
  i18n, currency, minAmount, session, collect_phone, hideDonorFields,
}) => {
  const donation = useValidation({
    i18n,
    currency,
    fieldSet: {
      amount: { required: true, min: minAmount, max: PLEDGE_MAX },
    }
  })

  const tip = useValidation({
    i18n,
    currency,
    fieldSet: {
      tip: {
        max: ({ state, tippingConfig }) => ({
          value: Math.max(state.amount, tippingConfig.options.at(-1)),
          message: 'more_than_donation',
        }),
      }
    }
  })

  const contact = useValidation((() => {
    // Nothing of ours to validate when Blackbaud's iframe owns these.
    const fieldSet = hideDonorFields ? {} : {
      firstName:  { required: true, maxLength: 30 },
      lastName:   { required: true, maxLength: 30 }
    }

    if (session.collect_email && !hideDonorFields)
      fieldSet.email = { required: true, maxLength: 75, email: true }

    if (collect_phone)
      fieldSet.phone = { required: true }

    return { i18n, currency, fieldSet }
  })())

  return { donation, tip, contact }
}

export default useValidations
